module.exports = __webpack_public_path__ + "img/bind-back-2.98f66de.png";